import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

// Used to track Subscription Reliability
export const subscriptionConnectionExperience = new UFOExperience(
	'service-management.help-center.omnichannel-v2.subscription-connection',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const omnichannelPageLoadExperience = new UFOExperience(
	'service-management.help-center.omnichannel-v2.page-load',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
